import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunkMiddleware from "redux-thunk";
import * as reducers from "reducers/courseCompassReducers";

const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;
// App Reducer to Handle App cases
const appReducer = combineReducers(reducers);

export const store = createStore(
  appReducer,
  composeEnhancers(applyMiddleware(thunkMiddleware))
);
